import {
  Box,
  CircularProgress,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
} from "@material-ui/core"
import { createReviewer } from "actions/Clerk/entities"
import ButtonRounded from "components/Common/ButtonRounded"
import AppContext from "contexts/App"
import { Form, Formik } from "formik"
import PropTypes from "prop-types"
import { useContext, useRef } from "react"
import { useMutation, useQueryClient } from "react-query"
import * as Yup from "yup"

import useStyles from "./styles"

const schema = Yup.object().shape({
  first_name: Yup.string(),
  last_name: Yup.string(),
  email: Yup.string().email("Please enter a valid email").required(`Required`),
  role_district: Yup.string(),
})

const CreateNewReviewerForm = ({ handleClose, entityId }) => {
  const classes = useStyles()
  const formRef = useRef()
  const queryClient = useQueryClient()
  const createReviewerMutation = useMutation(createReviewer)
  const { openSnackBar } = useContext(AppContext)

  const onSubmit = (values) => {
    let data = { entityId: entityId, ...values }
    createReviewerMutation
      ?.mutateAsync(data)
      ?.then((res) => {
        queryClient.setQueryData(["reviewersData", entityId], (oldData) => {
          return [...oldData, res]
        })
        openSnackBar({ message: "Reviewer created" })
        handleClose()
      })
      .catch((err) => {
        openSnackBar({ message: "Error creating reviewer" })
      })
  }

  return (
    <>
      <Formik
        initialValues={{
          first_name: "",
          last_name: "",
          email: "",
          role_district: "",
        }}
        onSubmit={onSubmit}
        validationSchema={schema}
        innerRef={formRef}
      >
        {({
          handleChange,
          values,
          errors,
          touched,
          handleBlur,
          isSubmitting,
          handleSubmit,
          setErrors,
        }) => (
          <Form onSubmit={handleSubmit}>
            <DialogContent className={classes.contentContainer}>
              <Typography className={classes.label}>First Name</Typography>
              <TextField
                type="text"
                name="first_name"
                id="first_name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.first_name}
                variant="outlined"
                fullWidth
                style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
                helperText={touched.first_name && errors.first_name}
                error={touched.first_name && errors.first_name}
                FormHelperTextProps={{
                  className: classes.formHelperText,
                }}
              />
              <Typography className={classes.label}>Last Name</Typography>
              <TextField
                type="text"
                name="last_name"
                id="last_name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.last_name}
                variant="outlined"
                fullWidth
                style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
                helperText={touched.last_name && errors.last_name}
                error={touched.last_name && errors.last_name}
                FormHelperTextProps={{
                  className: classes.formHelperText,
                }}
              />

              <Typography className={classes.label}>Email</Typography>
              <TextField
                type="text"
                name="email"
                id="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                variant="outlined"
                fullWidth
                style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
                helperText={touched.email && errors.email}
                error={touched.email && errors.email}
                FormHelperTextProps={{
                  className: classes.formHelperText,
                }}
              />
              <Typography className={classes.label}>Role District</Typography>
              <TextField
                type="text"
                name="role_district"
                id="role_district"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.role_district}
                variant="outlined"
                fullWidth
                style={{ backgroundColor: "#F8F8F8", marginBottom: "20px" }}
                helperText={touched.role_district && errors.role_district}
                error={touched.role_district && errors.role_district}
                FormHelperTextProps={{
                  className: classes.formHelperText,
                }}
              />
            </DialogContent>
            <DialogActions>
              <Box display="flex" justifyContent="center" width="100%">
                <ButtonRounded
                  color="primary"
                  variant="outlined"
                  onClick={handleClose}
                  type="button"
                >
                  Close
                </ButtonRounded>
                <ButtonRounded
                  color="primary"
                  variant="contained"
                  type="submit"
                  className={classes.saveButton}
                  disabled={createReviewerMutation?.isLoading}
                >
                  {createReviewerMutation?.isLoading ? (
                    <Box>
                      <CircularProgress size={15} />
                    </Box>
                  ) : (
                    "Create"
                  )}
                </ButtonRounded>
              </Box>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </>
  )
}

CreateNewReviewerForm.propTypes = {
  handleClose: PropTypes.func,
  entityId: PropTypes.number,
}

export default CreateNewReviewerForm
